import React from "react";
import { Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import LoadingButtonWithForm from "../../../components/LoadingButtonWithForm";
import { Link, useParams } from "react-router-dom";
import { convertToFormData, sweetAlert } from "../../../utils";
import { useSaveApplicationMutation } from "../../../redux/services/ApplicationService";
import { responseError } from "../../../helpers/responseHandler";
import { FILE_URL } from "../../../redux/services/apiConstant";

const StepTwo = ({ setActiveStep, params, isEdit, setIsEdit }) => {
  let {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm();
  const [editRequest, { isLoading: editLoading }] =
    useSaveApplicationMutation();

  const onSubmit = async (data) => {
    const newForm = convertToFormData({ step_no: "2", ...data });
    setIsEdit((prev) => {
      return { ...prev, ...newForm };
    });
    await editRequest({ params, newForm })
      .unwrap()
      .then((res) => {
        setActiveStep(2);
        if (res?.status) {
          sweetAlert(res?.message, "success");
        }
        // if (res?.errors) {
        //     Object.entries(res?.errors)?.forEach(([key, value]) => {
        //         sweetAlert(value[0], 'error')
        //     })
        // }
      })
      .catch((err) => {
        responseError(err);
      });
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-xl-9">
          <div className="card custom-card">
            <div className="card-body">
              <h5 className="text-center">Driver’s License Information</h5>
              <div className="row">
                <Form
                  onSubmit={handleSubmit(onSubmit)}
                  className="col-md-12"
                  id="application-status"
                >
                  <div className="row">
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Driver’s License Number:</Form.Label>
                        <Controller
                          name="dln"
                          control={control}
                          defaultValue={isEdit?.dln || ""}
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="text"
                              placeholder="Enter Driver’s License Number"
                              isInvalid={errors.dln}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>State of Issuance:</Form.Label>
                        <Controller
                          name="state_of_issuance"
                          control={control}
                          defaultValue={isEdit?.state_of_issuance || ""}
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="text"
                              placeholder="Enter State of Issuance"
                              isInvalid={errors.state_of_issuance}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>License Class:</Form.Label>
                        <Controller
                          name="license_class"
                          control={control}
                          defaultValue={isEdit?.license_class || ""}
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="text"
                              placeholder="Enter License Class"
                              isInvalid={errors.license_class}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Status:</Form.Label>
                        <Controller
                          name="license_status"
                          control={control}
                          defaultValue={isEdit?.license_status || ""}
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="text"
                              placeholder="Enter Status"
                              isInvalid={errors.license_status}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Restrictions:</Form.Label>
                        <Controller
                          name="restrictions"
                          control={control}
                          defaultValue={isEdit?.restrictions || ""}
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="text"
                              placeholder="Enter Restrictions"
                              isInvalid={errors.restrictions}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Endorsements:</Form.Label>
                        <Controller
                          name="endorsements"
                          control={control}
                          defaultValue={isEdit?.endorsements || ""}
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="text"
                              placeholder="Enter Endorsements"
                              isInvalid={errors.endorsements}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Issue Date:</Form.Label>
                        <Controller
                          name="issue_date"
                          control={control}
                          defaultValue={isEdit?.issue_date || ""}
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="date"
                              placeholder="Enter Issue Date"
                              isInvalid={errors.issue_date}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Expiration Date:</Form.Label>
                        <Controller
                          name="expiration_date"
                          control={control}
                          defaultValue={isEdit?.expiration_date || ""}
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="date"
                              placeholder="Enter Expiration Date"
                              isInvalid={errors.expiration_date}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Upload Front Copy of Driver's License:
                        </Form.Label>
                        <Controller
                          name="driver_license_copy"
                          control={control}
                          defaultValue={""}
                          rules={{
                            required: isEdit?.driver_license_copy
                              ? false
                              : true,
                            validate: {
                              fileSize: (file) => {
                                if (!file) return true; // allow empty if not required
                                return (
                                  file.size <= 5 * 1024 * 1024 ||
                                  "File size must be less than 5MB"
                                );
                              },
                              fileType: (file) => {
                                if (!file) return true; // skip if not required
                                const allowedTypes = [
                                  "image/jpeg",
                                  "image/png",
                                  "application/pdf",
                                ];
                                return (
                                  allowedTypes.includes(file.type) ||
                                  "Only JPEG, PNG, or PDF files are allowed"
                                );
                              },
                            },
                          }}
                          render={({ field }) => (
                            <>
                              <Form.Control
                                type="file"
                                onChange={(e) =>
                                  field.onChange(e.target.files[0])
                                }
                                isInvalid={errors.driver_license_copy}
                              />
                              {errors.driver_license_copy && (
                                <Form.Control.Feedback type="invalid">
                                  {errors.driver_license_copy.message}
                                </Form.Control.Feedback>
                              )}
                            </>
                          )}
                        />
                        {isEdit?.driver_license_copy_url && (
                          <Link
                            to={isEdit?.driver_license_copy_url || ""}
                            target="_blank"
                          >
                            <span className="d-inline-block text-primary my-1">
                              View Uploaded File
                            </span>
                          </Link>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Upload Back Copy of Driver's License:
                        </Form.Label>
                        <Controller
                          name="driver_license_back"
                          control={control}
                          defaultValue={""}
                          rules={{
                            required: isEdit?.driver_license_back
                              ? false
                              : true,
                            validate: {
                              fileSize: (file) => {
                                if (!file) return true; // allow empty if not required
                                return (
                                  file.size <= 5 * 1024 * 1024 ||
                                  "File size must be less than 5MB"
                                );
                              },
                              fileType: (file) => {
                                if (!file) return true; // skip if not required
                                const allowedTypes = [
                                  "image/jpeg",
                                  "image/png",
                                  "application/pdf",
                                ];
                                return (
                                  allowedTypes.includes(file.type) ||
                                  "Only JPEG, PNG, or PDF files are allowed"
                                );
                              },
                            },
                          }}
                          render={({ field }) => (
                            <>
                              <Form.Control
                                type="file"
                                onChange={(e) =>
                                  field.onChange(e.target.files[0])
                                }
                                isInvalid={errors.driver_license_back}
                              />
                              {errors.driver_license_back && (
                                <Form.Control.Feedback type="invalid">
                                  {errors.driver_license_back.message}
                                </Form.Control.Feedback>
                              )}
                            </>
                          )}
                        />
                        {isEdit?.driver_license_back_url && (
                          <Link
                            to={isEdit?.driver_license_back_url || ""}
                            target="_blank"
                          >
                            <span className="d-inline-block text-primary my-1">
                              View Uploaded File
                            </span>
                          </Link>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3 d-flex align-items-center">
                        <Controller
                          name="add_reminder"
                          control={control}
                          defaultValue={false}
                          rules={{
                            required: isEdit?.driver_license_back
                              ? false
                              : true,
                          }}
                          render={({ field }) => {
                            const checkboxId = "addReminderCheckbox";

                            return (
                              <>
                                <Form.Check
                                  id={checkboxId}
                                  type="checkbox"
                                  {...field}
                                  checked={field.value}
                                />
                                <Form.Label htmlFor={checkboxId}>
                                  Add Reminder for driving licence
                                </Form.Label>
                              </>
                            );
                          }}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Form>
                <div className="col-lg-3 d-flex mb-3">
                  <Button
                    variant="secondary"
                    className="mt-auto w-100"
                    onClick={() => setActiveStep(0)}
                  >
                    Previous
                  </Button>
                </div>
                <div className="col-lg-3 d-flex mb-3">
                  {/* <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(2)}
                                    >
                                        Next
                                    </Button> */}
                  <LoadingButtonWithForm
                    isLoading={editLoading}
                    name="Next & Save"
                    form="application-status"
                    className="w-100"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepTwo;
